import Connector, { takeQuery } from '../../agent';
import types from './types';

const HazardStatements = {
  getHazardStatementAutocompleteList: () => Connector.api.get('/hazardStatements/autocomplete')
};

const EuhStatements = {
  getEuhStatementAutocompleteList: () => Connector.api.get('/euhStatements/autocomplete')
};


const hazardStatementSagas = [
  takeQuery(
    types.GET_HAZARD_STATEMENT_AUTOCOMPLETE_LIST,
    HazardStatements.getHazardStatementAutocompleteList
  ),
  takeQuery(
    types.GET_EUH_STATEMENT_AUTOCOMPLETE_LIST,
    EuhStatements.getEuhStatementAutocompleteList
  )
];

export default hazardStatementSagas;
